import { Form, Formik } from "formik";
import { FormikInput } from "@/components/common/form/FormikInput.tsx";
import { Button } from "@/components/base/Button.tsx";
import { FormikCheckbox } from "@/components/common/form/FormikCheckbox.tsx";
import * as yup from "yup";
import { useStore } from "@/stores/useStore.ts";

const validationSchema = yup.object({
  firstname: yup.string().required("First name is required"),
  lastname: yup.string().required("Last name is required"),
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),
  password: yup
    .string()
    .min(8, "Password should be of minimum 8 characters length")
    .required("Password is required"),
  confirm_password: yup
    .string()
    .required("Required")
    .oneOf([yup.ref("password"), ""], "Passwords must match"),
  terms: yup.boolean().oneOf([true], "Terms must be accepted"),
});

export const RegisterForm = () => {
  const registerUser = useStore((s) => s.register);
  return (
    <Formik
      initialValues={{
        firstname: "",
        lastname: "",
        email: "",
        password: "",
        terms: false,
      }}
      onSubmit={(values) => registerUser(values)}
      validationSchema={validationSchema}
    >
      {({ isValid }) => (
        <Form className="flex flex-col gap-4 m-auto sm:w-64">
          <FormikInput
            name="firstname"
            id="firstname"
            label="First Name"
            type="text"
          />
          <FormikInput
            name="lastname"
            id="lastname"
            label="Last Name"
            type="text"
          />
          <FormikInput name="email" id="email" label="E-mail" type="email" />
          <FormikInput
            name="password"
            id="password"
            label="Password"
            type="password"
          />
          <FormikInput
            name="confirm_password"
            id="confirm_password"
            label="Confirm Password"
            type="password"
          />
          <FormikCheckbox
            label="I agree to the Terms and Conditions"
            name="terms"
            id="terms"
          />
          <Button disabled={!isValid} type="submit">
            Submit
          </Button>
        </Form>
      )}
    </Formik>
  );
};
